import { Box, Menu, MenuItem } from "@mui/material";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import React, { useEffect, useState } from "react";

const TimeSelector = ({ initialValue, handleFilters }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [timeFilter, setTimeFilter] = useState(initialValue);

  const timeFilterItem = [
    { label: "Last Week", value: "Last 7 days" },
    { label: "Last Month", value: "Last 30 days" },
    { label: "Last 3 Months", value: "Last 3 Months" },
    { label: "Any Time", value: "All" },
  ];

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleMenuItemClick = (filterItem) => {
    setTimeFilter(filterItem);
    handleMenuClose();
  };

  useEffect(() => {
    if (timeFilter) handleFilters(timeFilter);
  }, [timeFilter]);

  return (
    <>
      <Box
        id="jobs-menu-button"
        aria-controls={Boolean(anchorEl) ? "jobs-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={Boolean(anchorEl) ? "true" : undefined}
        onClick={handleMenuClick}
        sx={{
          background: "#FFF",
          px: 1.25,
          py: 0.75,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          cursor: "pointer",
          color: "#000",
          borderRadius: 1.5,
          width: "fit-content",
        }}
      >
        <span style={{ width: "100%", fontSize: "14px" }}>
          {timeFilter?.value}
        </span>
        <KeyboardArrowDownOutlinedIcon sx={{ fontSize: "16px" }} />
      </Box>
      <Menu
        id="jobs-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        MenuListProps={{ "aria-labelledby": "jobs-menu-button" }}
        sx={{ "& ul": { padding: "4px 0" } }}
      >
        {timeFilterItem.map((filterItem) => (
          <MenuItem
            key={filterItem.value}
            onClick={() => handleMenuItemClick(filterItem)}
            sx={{
              mx: 0.5,
              mb: filterItem.label === "Any Time" ? "" : 0.5,
              px: 1.5,
              borderRadius: 1,
              fontSize: "12px",
              color: "#000 !important",
              background:
                timeFilter?.label === filterItem.label
                  ? "#d8eaf8 !important"
                  : "transparent !important",
              "&:hover": { background: "#E0E0E0 !important" },
              "&.Mui-focusVisible": { background: "#E0E0E0 !important" },
            }}
          >
            {filterItem.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TimeSelector;
